const DELIVERY_TYPE_ENUM = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
  BEACH: 'beach',
};
export default DELIVERY_TYPE_ENUM;
